import { defineNuxtPlugin } from "#app";
import Aura from '@primevue/themes/aura'
import PrimeVue from "primevue/config";
import Button from "primevue/button";
import Badge from "primevue/badge";
import BadgeDirective from "primevue/badgedirective";
import Ripple from "primevue/ripple";
import StyleClass from "primevue/styleclass";
import InputText from "primevue/inputtext";
import Accordion from "primevue/accordion";
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import Avatar from "primevue/avatar";
import ConfirmDialog from 'primevue/confirmdialog';
import AvatarGroup from "primevue/avatargroup";
import DatePicker from "primevue/datepicker";
import Carousel from "primevue/carousel";
import Checkbox from "primevue/checkbox";
import Chip from "primevue/chip";
import InputChips from "primevue/inputchips";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import DataView from "primevue/dataview";
import Dialog from "primevue/dialog";
import Divider from "primevue/divider";
import Select from "primevue/select";
import FileUpload from "primevue/fileupload";
import Galleria from "primevue/galleria";
import InputMask from "primevue/inputmask";
import InputNumber from "primevue/inputnumber";
import ToggleSwitch from "primevue/toggleswitch";
import TieredMenu from 'primevue/tieredmenu'
import Knob from "primevue/knob";
import Menu from "primevue/menu";
import Message from "primevue/message";
import MultiSelect from "primevue/multiselect";
import Password from "primevue/password";
import ProgressBar from "primevue/progressbar";
import ProgressSpinner from "primevue/progressspinner";
import RadioButton from "primevue/radiobutton";
import Rating from "primevue/rating";
import Drawer from "primevue/drawer";
import Slider from "primevue/slider";
import SelectButton from "primevue/selectbutton";
import TabMenu from "primevue/tabmenu";
import TabPanel from "primevue/tabpanel";
import Tabs from "primevue/tabs";
import Tag from "primevue/tag";
import Textarea from "primevue/textarea";
import ToggleButton from "primevue/togglebutton";
import Tooltip from "primevue/tooltip";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import Listbox from "primevue/listbox";
import Panel from "primevue/panel";
import Skeleton from "primevue/skeleton";
import ContextMenu from "primevue/contextmenu";
import Popover from "primevue/popover";



export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(PrimeVue, { ripple: true,
    theme: {
    preset: Aura,
      options: {
        prefix: 'p',
        darkMode: true,
      }
    },
    locale: {
    firstDayOfWeek: 1,
    }
  });
  nuxtApp.vueApp.component("Button", Button);
  nuxtApp.vueApp.component("Skeleton", Skeleton);
  nuxtApp.vueApp.component("ContextMenu", ContextMenu);
  nuxtApp.vueApp.component("Badge", Badge);
  nuxtApp.vueApp.component("InputText", InputText);
  nuxtApp.vueApp.component("Accordion", Accordion);
  nuxtApp.vueApp.component("AccordionPanel", AccordionPanel);
  nuxtApp.vueApp.component("AccordionHeader", AccordionHeader);
  nuxtApp.vueApp.component("AccordionContent", AccordionContent);
  nuxtApp.vueApp.component("Avatar", Avatar);
  nuxtApp.vueApp.component("AvatarGroup", AvatarGroup);
  nuxtApp.vueApp.component("Calendar", DatePicker);
  nuxtApp.vueApp.component("Carousel", Carousel);
  nuxtApp.vueApp.component("Checkbox", Checkbox);
  nuxtApp.vueApp.component("Chip", Chip);
  nuxtApp.vueApp.component("Chips", InputChips);
  nuxtApp.vueApp.component("Column", Column);
  nuxtApp.vueApp.component("DataTable", DataTable);
  nuxtApp.vueApp.component("DataView", DataView);
  nuxtApp.vueApp.component("Dialog", Dialog);
  nuxtApp.vueApp.component("Divider", Divider);
  nuxtApp.vueApp.component("Dropdown", Select);
  nuxtApp.vueApp.component("FileUpload", FileUpload);
  nuxtApp.vueApp.component("Galleria", Galleria);
  nuxtApp.vueApp.component("InputMask", InputMask);
  nuxtApp.vueApp.component("InputNumber", InputNumber);
  nuxtApp.vueApp.component("InputSwitch", ToggleSwitch);
  nuxtApp.vueApp.component("Knob", Knob);
  nuxtApp.vueApp.component("Menu", Menu);
  nuxtApp.vueApp.component("Message", Message);
  nuxtApp.vueApp.component("MultiSelect", MultiSelect);
  nuxtApp.vueApp.component("Password", Password);
  nuxtApp.vueApp.component("ProgressBar", ProgressBar);
  nuxtApp.vueApp.component("ProgressSpinner", ProgressSpinner);
  nuxtApp.vueApp.component("RadioButton", RadioButton);
  nuxtApp.vueApp.component("Rating", Rating);
  nuxtApp.vueApp.component("Drawer",Drawer);
  nuxtApp.vueApp.component("SelectButton", SelectButton);
  nuxtApp.vueApp.component("Slider", Slider);
  nuxtApp.vueApp.component("TabMenu", TabMenu);
  nuxtApp.vueApp.component("TabPanel", TabPanel);
  nuxtApp.vueApp.component("TabView", Tabs);
  nuxtApp.vueApp.component("Tag", Tag);
  nuxtApp.vueApp.component("Textarea", Textarea);
  nuxtApp.vueApp.component("ToggleButton", ToggleButton);
  nuxtApp.vueApp.component("Toast", Toast);
  nuxtApp.vueApp.component("Listbox", Listbox);
  nuxtApp.vueApp.component("Panel", Panel);
  nuxtApp.vueApp.component("TieredMenu", TieredMenu);
  nuxtApp.vueApp.component("ConfirmDialog", ConfirmDialog);
  nuxtApp.vueApp.component("Popover", Popover);


  nuxtApp.vueApp.directive("badge", BadgeDirective);
  nuxtApp.vueApp.directive("tooltip", Tooltip);
  nuxtApp.vueApp.directive("ripple", Ripple);
  nuxtApp.vueApp.directive("styleclass", StyleClass);

  nuxtApp.vueApp.use(ToastService);
  nuxtApp.vueApp.use(ConfirmationService);
  //other components that you need

  nuxtApp.provide("PrimeVue", PrimeVue);
});
